import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import injectSheet from 'react-jss';
import Typography from '../Typography';

function FormLabel({ classes, className, ...other }) {
  return <Typography type="label" className={classNames(classes.root, className)} {...other} />;
}

FormLabel.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
};

FormLabel.defaultProps = {
  className: null,
};

const stylesheet = theme => ({
  root: {
    color: theme.palette.common.lightBlack,
  },
});

export default injectSheet(stylesheet)(FormLabel);



// WEBPACK FOOTER //
// ./src/site-render/src/FormLabel/FormLabel.js